export const eur = (n) => new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR" }).format(n || 0);
export const STATI_FATTURA = {
  da_pagare: { label: "Da pagare", cls: "bg-amber-50 text-amber-800 border-amber-200" },
  scaduta: { label: "Scaduta", cls: "bg-red-50 text-[#C8102E] border-red-200" },
  pagata: { label: "Pagata", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
};
export const MESI = ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"];
export const fmtDay = (s) => (s ? s.split("-").reverse().join("/") : "—");
export const openBlob = (data, name, download) => {
  const url = URL.createObjectURL(data);
  if (download) { const a = document.createElement("a"); a.href = url; a.download = name; a.click(); }
  else window.open(url, "_blank", "noopener");
  setTimeout(() => URL.revokeObjectURL(url), 60000);
};
